import styled from 'styled-components'

export const Nav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 10vh;
  padding: 20px;
`
export const Logo = styled.img`
  height: 50px;
  width: 150px;
`

export default Logo
